import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Truck, ArrowLeft } from "lucide-react";

export default function Impressum() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-slate-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-3">
              <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
                <Truck className="h-6 w-6 text-white" />
              </div>
              <div>
                <span className="font-bold text-lg">SonderCargo.de</span>
                <span className="text-xs text-slate-400 block">Medical, Weapons and much more</span>
              </div>
            </Link>
            
            <Link to="/">
              <Button variant="ghost" className="text-slate-300 hover:text-white">
                <ArrowLeft className="h-4 w-4 mr-2" />
                Zurück
              </Button>
            </Link>
          </div>
        </div>
        <div className="h-1 bg-gradient-to-r from-blue-600 via-blue-500 to-blue-400" />
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-3xl font-bold text-slate-900 mb-8">Impressum</h1>
        
        <div className="prose prose-slate max-w-none">
          <h2 className="text-xl font-semibold text-slate-900 mb-4">Angaben gemäß § 5 DDG</h2>
          
          <div className="mb-8">
            <p className="text-slate-700 mb-1"><strong>SM-Medical UG (haftungsbeschränkt)</strong></p>
            <p className="text-slate-700 mb-1">SM-Medical UG</p>
            <p className="text-slate-700 mb-1">Franz-Schubert-Straße 7</p>
            <p className="text-slate-700">84518 Garching an der Alz</p>
          </div>
          
          <div className="mb-8">
            <h3 className="text-lg font-semibold text-slate-900 mb-2">Vertreten durch:</h3>
            <p className="text-slate-700">Sandra Krivic</p>
          </div>
          
          <div className="mb-8">
            <h3 className="text-lg font-semibold text-slate-900 mb-2">Registereintrag:</h3>
            <p className="text-slate-700 mb-1">Eintragung im Handelsregister.</p>
            <p className="text-slate-700 mb-1">Registergericht: Traunstein</p>
            <p className="text-slate-700">Registernummer: HRB 35041</p>
          </div>
          
          <div className="mb-8">
            <h3 className="text-lg font-semibold text-slate-900 mb-2">Verbraucherstreitbeilegung / Universalschlichtungsstelle</h3>
            <p className="text-slate-700">
              Wir nehmen nicht an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teil und sind dazu auch nicht verpflichtet.
            </p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-slate-900 text-white py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-slate-400 text-sm">
            © 2026 SM-Medical UG (haftungsbeschränkt)
          </p>
        </div>
      </footer>
    </div>
  );
}
